// SPDX-License-Identifier: AGPL-3.0-or-later

import {AvatarDecorationMedia} from '@app/features/user/components/AvatarDecorationMedia';
import styles from '@app/features/user/components/ProfileFrameOverlay.module.css';
import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import ProfileFrameCatalog from '@app/features/user/state/ProfileFrameCatalog';
import Users from '@app/features/user/state/Users';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';
import {useEffect} from 'react';

interface ProfileFrameOverlayProps {
	userId: string;
	frameId?: string | null;
	className?: string;
	fit?: 'preview' | 'popout';
}

export const ProfileFrameOverlay = observer(function ProfileFrameOverlay({
	userId,
	frameId,
	className,
	fit = 'preview',
}: ProfileFrameOverlayProps) {
	useEffect(() => {
		void ProfileFrameCatalog.load();
	}, []);
	const equippedId = frameId ?? Users.getProfileFrameId(userId) ?? null;
	const entry = ProfileFrameCatalog.getById(equippedId);
	if (!entry) {
		return null;
	}
	if (!RuntimeConfig.profileFramesEnabled) {
		return null;
	}
	const hasBottom = Boolean(entry.bottom);
	return (
		<div className={clsx(styles.overlay, fit === 'popout' && styles.overlayPopout, className)} aria-hidden="true">
			<div className={clsx(styles.piece, hasBottom ? styles.top : styles.full)}>
				<AvatarDecorationMedia src={entry.top} className={styles.media} active={true} />
			</div>
			{entry.bottom ? (
				<div className={clsx(styles.piece, styles.bottom)}>
					<AvatarDecorationMedia src={entry.bottom} className={styles.media} active={true} />
				</div>
			) : null}
		</div>
	);
});

interface ProfileFramePreviewProps {
	frameId: string;
	className?: string;
}

export const ProfileFramePreview = observer(function ProfileFramePreview({
	frameId,
	className,
}: ProfileFramePreviewProps) {
	return <ProfileFrameOverlay userId="" frameId={frameId} className={className} />;
});
